<div class="inv-card">
  <div class="inv-header">
    <div>
      <div class="inv-label">Inventory Health</div>
      <div class="inv-value-row">
        <span class="inv-value-big">{{ displayRatio }}</span>
        <span class="inv-value-sub" *ngIf="state !== ItemPriceState.DEAD_STOCK && state !== ItemPriceState.NO_DEMAND; else notMoveTag"
          >Risk Ratio</span
        >

        <ng-template #notMoveTag>
          <span class="inv-value-sub" *ngIf="state === ItemPriceState.DEAD_STOCK || state === ItemPriceState.NO_DEMAND"
            >No Movement</span
          >
        </ng-template>
      </div>
    </div>

    <div
      class="inv-status-box"
      [ngClass]="currentClass"
      [ngbTooltip]="'Current State'"
    >
      <div class="inventory-health-chip">
        <span
          style="width: 18px"
          [innerHTML]="
            sanitizer.bypassSecurityTrustHtml(
              REPRICING_INVENTORY_STATUS_STATE_DISPLAY[state]?.icon
            )
          "
        ></span>
        <span>{{
          REPRICING_INVENTORY_STATUS_STATE_DISPLAY[state]?.title
        }}</span>
      </div>
    </div>
  </div>

  <div
    class="inv-chart-container"
    [ngClass]="{ 'disabled-chart': isSpecialState }"
  >
    <div class="inv-bar">
      <ng-container
        *ngIf="
          !isSpecialState &&
          state !== ItemPriceState.STOCK_OUT_RESTOCKING &&
          state !== ItemPriceState.STOCK_OUT_HIGH_DEMAND
        "
      >
        <ng-container *ngFor="let segment of statusSegments">
          <ng-template #unifiedTooltip>
            <div
              *ngIf="
                REPRICING_INVENTORY_STATUS_STATE_DISPLAY[segment.state]
                  ?.tooltip as tooltipContent
              "
            >
              <div>
                <strong>{{ tooltipContent?.header }}</strong>
              </div>
              <div class="text-sm">{{ tooltipContent?.range }}</div>
              <hr class="ml-4 mr-4" />
              <p class="text-left">
                <strong class="text-primary">Description:</strong>
                {{ tooltipContent?.body }}
              </p>
              <hr class="ml-4 mr-4" />
              <div class="text-left">
                <strong class="text-primary">Action:</strong>
                {{ tooltipContent?.action }}
              </div>
            </div>
          </ng-template>

          <div
            class="inv-seg"
            [class.active]="state === segment.state"
            [ngClass]="segment.class"
            [ngbTooltip]="unifiedTooltip"
            tooltipClass="inventory-health-tooltip"
          >
            <span>
              {{
                REPRICING_INVENTORY_STATUS_STATE_DISPLAY[segment.state]?.tooltip
                  ?.header
              }}
            </span>
          </div>
        </ng-container>
      </ng-container>

      <div
        *ngIf="state === ItemPriceState.DEAD_STOCK || state === ItemPriceState.NO_DEMAND"
        class="inv-seg"
        style="background: #e5e7eb; width: 100%"
      ></div>

      <div
        *ngIf="state === ItemPriceState.MISSING_PRICE"
        class="inv-seg"
        style="background: #fee2e2; width: 100%"
      ></div>
    </div>

    <div class="inv-labels" *ngIf="!isSpecialState">
      <ng-container *ngFor="let titleSegment of titleSegments">
        <div class="d-flex align-items-center">
          <span>{{ titleSegment.startPoint }}</span>
          <div
            class="flex-grow-1 relative h-100"
            *ngIf="
              !isSpecialState &&
              state !== ItemPriceState.STOCK_OUT_RESTOCKING &&
              state !== ItemPriceState.STOCK_OUT_HIGH_DEMAND
            "
          >
            <div class="inv-labels__title">
              <ng-container
                *ngTemplateOutlet="
                  percentageTemplate;
                  context: { percentage: titleSegment?.changePercent || 0 }
                "
              ></ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="inv-labels" *ngIf="state === ItemPriceState.DEAD_STOCK || state === ItemPriceState.NO_DEMAND">
      <span>Metric Unavailable</span>
    </div>
    <div class="inv-labels" *ngIf="state === ItemPriceState.MISSING_PRICE">
      <span>Cannot calculate ratio</span>
    </div>

    <div
      class="inv-indicator"
      [style.left.%]="indicatorLeft"
      *ngIf="!isSpecialState"
    >
      <div class="ind-tag" [ngClass]="currentClass">
        {{ riskRatio || (state === ItemPriceState.MISSING_PRICE ? "N/A" : 0) }}
      </div>
      <div class="ind-arrow"></div>
      <div class="ind-line"></div>
    </div>
  </div>
</div>

<ng-template #percentageTemplate let-percentage="percentage">
  <!-- Increase Badge -->
  <div *ngIf="percentage > 0" class="badge increase">
    <span>+{{ percentage }}%</span>
  </div>

  <!-- Decrease Badge -->
  <div *ngIf="percentage < 0" class="badge decrease">
    <span>{{ percentage }}%</span>
  </div>

  <div *ngIf="!percentage" class="badge maintain">
    <span>Maintain</span>
  </div>
</ng-template>
